import checkMarkIcon from '../../../../static/icons/icon_check-mark_green.svg';

type Properties = {
    isHidden: boolean;
    isRecommended: boolean;
    imagePath: string; // relative to static
    onClick: () => void;
    hasCheckMark?: boolean;
};

const checkMark = <img 
    src={checkMarkIcon} 
    className="session-start-button-icon-done"
/>;

const SlotDropdownItemStartButton = (props: Properties) => {
    // Dynamic imports need to be handled at build time, so we use require with a template
    const imageSource = require(`../../../../static/${props.imagePath}`).default || require(`../../../../static/${props.imagePath}`);

    let buttonStyle = { filter: ''};
    if (props.isHidden) {
        buttonStyle.filter += ' opacity(0)';
    }
    if (!props.isRecommended) {
        buttonStyle.filter += ' grayscale(1)';
    }

    let onClick = props.onClick;
    if (props.isHidden) {
        onClick = () => { return; };
    }

    return (
        <button
            className="action-button"
            onClick={onClick}
            style={buttonStyle}
            data-testid="slot-dropdown-item-start-button"
        >
            <img 
                src={imageSource} 
                style={buttonStyle}
                className="session-start-button-icon"
                data-testid="slot-dropdown-item-start-button-image"
            />
            {!props.isHidden && props.hasCheckMark && checkMark}
        </button>
    );
};
export default SlotDropdownItemStartButton;
